import { render } from "./GridOfficeLayout.vue?vue&type=template&id=66d5f720"
import script from "./GridOfficeLayout.vue?vue&type=script&lang=js"
export * from "./GridOfficeLayout.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Раиль\\Desktop\\Projects\\Mercury\\topaz.plugin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__